"use client"
import { useState, useEffect } from "react"

const ContactForm = ({ onBack }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    ahpraNumber: "",
    practiceName: "",
    practiceAddress: "",
    phoneNumber: "",
    email: "",
    enquiryNature: "",
    message: "",
  })
  const [showPopup, setShowPopup] = useState(false) // State for popup visibility

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      const response = await fetch("https://tarquinnm.readyforyourreview.com/laravel/public/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      })

      const result = await response.json()

      if (response.ok) {
        setShowPopup(true) // Show popup on success
        setFormData({
          fullName: "",
          ahpraNumber: "",
          practiceName: "",
          practiceAddress: "",
          phoneNumber: "",
          email: "",
          enquiryNature: "",
          message: "",
        })
      } else {
        alert(result.error || "Something went wrong.")
      }
    } catch (error) {
      console.error("Error:", error)
      alert("Failed to send message. Please try again later.")
    }
  }

  const closePopup = () => {
    setShowPopup(false) // Hide popup when close icon is clicked
  }

   // Scroll to top when the component mounts
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <div className="pt-44 pb-16 bg-stone-50 min-h-screen">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <button onClick={onBack} className="mb-8 text-emerald-800 hover:text-emerald-700 font-medium">
          ← Back to Home
        </button>

        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-center text-charcoal-800 mb-8">Send us a message</h1>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-2">Full Name *</label>
              <input
                type="text"
                name="fullName"
                required
                value={formData.fullName}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-2">AHPRA Number *</label>
              <input
                type="text"
                name="ahpraNumber"
                required
                value={formData.ahpraNumber}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-2">Practice/Pharmacy Name *</label>
              <input
                type="text"
                name="practiceName"
                required
                value={formData.practiceName}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-2">Practice/Pharmacy Address *</label>
              <input
                type="text"
                name="practiceAddress"
                required
                value={formData.practiceAddress}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-2">Phone Number</label>
              <input
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-2">Email *</label>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-2">Nature of Enquiry *</label>
              <select
                name="enquiryNature"
                required
                value={formData.enquiryNature}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              >
                <option value="">Select an option</option>
                <option value="product-information">Product information</option>
                <option value="ordering-information">Ordering information</option>
                <option value="education-request">Education request</option>
                <option value="product-feedback">Product feedback</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-2">Message *</label>
              <textarea
                name="message"
                required
                rows="4"
                maxLength="500"
                value={formData.message}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-vertical"
                placeholder="Please enter your message (max 500 characters)"
              />
              <p className="text-sm text-stone-500 mt-1">{formData.message.length}/500 characters</p>
            </div>

            <button
              type="submit"
              className="w-full bg-emerald-800 hover:bg-emerald-700 text-white py-3 px-6 rounded-md font-medium transition-colors"
            >
              Send Message
            </button>
          </form>
        </div>

        {/* Enhanced Popup for successful submission */}
        {showPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 transition-opacity duration-300">
            <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4 relative shadow-2xl transform transition-all duration-300 scale-100 hover:scale-105">
              <button
                onClick={closePopup}
                className="absolute top-4 right-4 bg-emerald-100 text-emerald-700 p-2 rounded-full hover:bg-emerald-200 transition-colors duration-200"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              <h3 className="text-2xl font-bold text-emerald-800 mb-3">Thank You!</h3>
              <p className="text-charcoal-600 text-base leading-relaxed">
                Your message has been sent successfully. Our team will respond to you shortly. We appreciate your inquiry!
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ContactForm